enum DestructibleType {
  GIFT = "GIFT",
  CHEST = "CHEST",
}

export default DestructibleType;
